import { z } from 'zod';
import { id } from '../atomic/id';

export const keyEmpSchema = z.object({
  id,
  firstName: z.string(),
  lastName: z.string(),
  access: z.object({
    role: z.string(),
    services: z.array(id).nullable(),
  }),
});
